import { Table } from '../../Table';
import useRankingTable from '../../../hooks/useRankingTable';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    isStatic: false,
    name: 'Ranking'
  },
  asset_macro_type: {
    isStatic: false,
    name: 'Macro-asset type'
  },
  sub_asset_type: {
    name: 'Sub-Asset type',
    isStatic: false
  },
  position_type: {
    isStatic: false,
    name: 'Position type'
  },
  aggregated_value: {
    isStatic: false,
    name: 'Aggregated value'
  },
  aggregated_value_rate: {
    isStatic: false,
    name: 'Aggregated value percentage'
  },
  entitiy_name: {
    isStatic: false,
    name: 'Counterparty Name'
  },

  // counterparty: {
  //   isStatic: true,
  //   name: 'Counterparty (if there is one)',
  //   description: '',
  // },
  entity_iden_lei: {
    isStatic: false,
    name: 'Counterparty LEI'
  },
  entity_iden_bic: {
    isStatic: false,
    name: 'Counterparty BIC'
  }
};

export function PrincipalExposures({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { tables, columns, onChange } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.PRINCIPAL_EXPOSURES,
    onChangeFund,
    schema: schema.PRINCIPAL_EXPOSURES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.PRINCIPAL_EXPOSURES?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'PRINCIPAL_EXPOSURES',
    order: 94,
    columnLables
  });

  return (
    <StyledTables id="reporttables-principal-exposures-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'PRINCIPAL_EXPOSURES'}
          id={`reporttables-principal-exposures-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
